import enUS from './en-US';
import zhCN from './zh-CN';
import deDE from './de-DE';

export default {
  'de-DE': deDE,
  'en-US': enUS,
  'es-ES': enUS,
  'et-EE': enUS,
  'fi-FI': enUS,
  'fr-FR': enUS,
  'ja-JP': enUS,
  'ko-KR': enUS,
  'pl-PL': enUS,
  'pt-BR': enUS,
  'sk-SK': enUS,
  'zh-CN': zhCN,
};
